export function unlockUserAchievement(id: string): void {
  const gameId = "real-or-ai";
  let achievementId = `${gameId}__${id}`;
  try {
    if (window.parent && (window.parent as any).unlockUserAchievement) {
      (window.parent as any).unlockUserAchievement(gameId, achievementId);
    }
  } catch (e) {
    console.warn("Error unlocking achievement on parent window:", e);
  }

  try {
    if (window && (window as any).unlockUserAchievement) {
      (window as any).unlockUserAchievement(gameId, achievementId);
    }
  } catch (e) {
    console.warn("Error unlocking achievement on current window:", e);
  }
}